import {
	AlertDialog,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "./ui/alert-dialog"
import { Check } from "lucide-react"
import { Spinner } from "./ui/spinner"
// import { Button } from "./ui/button"

interface SuccessPopupProps {
	open: boolean
	isRefferal: boolean
	setOpen: (open: boolean) => void
}

export const SuccessPopup = ({
	open,
	isRefferal,
	setOpen,
}: SuccessPopupProps) => {
	return (
		<AlertDialog
			open={open}
			onOpenChange={setOpen}
		>
			<AlertDialogContent
				className="rounded-2xl px-20 py-14 backdrop-blur-md"
				style={{
					maxWidth: "576px",
				}}
			>
				<AlertDialogHeader>
					<AlertDialogTitle>
						<div className="relative flex flex-col items-center gap-5">
							<div className="grid size-16 place-content-center rounded-full bg-green-500 p-3">
								<Check className="size-8 text-white" />
							</div>
							<p className="text-xl font-semibold">
								{isRefferal
									? "Invitation Successful"
									: "Submission Successfull"}
							</p>
							{/* <Button
								variant={"ghost"}
								onClick={() => setOpen(false)}
								className="absolute right-0 top-0 !px-3"
							>
								<X />
							</Button> */}
						</div>
					</AlertDialogTitle>
					{isRefferal ? (
						<AlertDialogDescription>
							<p className="text-center">
								Please review <b>My Rewards</b> to monitor your
								friend's progress. Refer your friends to earn
								more rewards!
							</p>
						</AlertDialogDescription>
					) : (
						<AlertDialogDescription>
							<p className="text-center">
								Thank you for your submission. We have received
								your information and will process it shortly.
							</p>
							<div className="flex items-center justify-center gap-3">
								<p className="text-center">
									please wait . Redirecting to
									dashboard....{" "}
								</p>
								<Spinner
									size={"small"}
									className="h-5 w-5"
								/>
							</div>
						</AlertDialogDescription>
					)}
				</AlertDialogHeader>
				<AlertDialogFooter></AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
